import { injectable, injectFromBase } from 'inversify'
import { RepoSettings } from '@/decorators/repositoryDecorators'
import type { Endpoint } from '@/services/endpoints'
import OrmApiRepository from '@/data/repositories/ormApiRepository'
import TenDlcPhoneNumber from '@/data/models/domain/services/regulations/TenDlcPhoneNumber'
import type { TenDlcPhoneNumbersLinkToCampaignBody } from '@/services/domain/services/regulations/tenDlcPhoneNumbers/types'
import type { TenDlcTwilioRequestStatus } from '@/services/domain/services/regulations/tenDlcRequest/types'
import type TenDlcRequest from '@/data/models/domain/services/regulations/TenDlcRequest'

@RepoSettings<Endpoint>({
  model: TenDlcPhoneNumber,
  fetch: 'tenDlcPhoneNumbers',
})
@injectable()
@injectFromBase()
export default class TenDlcPhoneNumbersRepository extends OrmApiRepository<TenDlcPhoneNumber> {
  public async linkToCampaign(body: TenDlcPhoneNumbersLinkToCampaignBody): Promise<void> {
    const path = this.endpointsService.getPath('tenDlcNumberLinkToCampaign')
    await this.getApiSource().post(path, body)
  }

  public async unlink(): Promise<TenDlcRequest> {
    const path = this.endpointsService.getPath('numberUnlink')
    const response = await this.getApiSource().get<TenDlcRequest>(path)

    return response.data
  }

  public getNumbersByStatus(status: TenDlcTwilioRequestStatus) {
    const queryParameters = {
      filter: [],
      other: {
        status,
      },
    }
    return this.doGrid(this.getSettingsFetch(), [], queryParameters)
  }

  public async getNumbersByCampaignId(campaignId: string): Promise<TenDlcPhoneNumber[]> {
    const queryParameters = {
      perPage: 250,
      filter: [],
      other: {
        campaignId,
      },
    }

    const data = await this.doGrid(this.getSettingsFetch(), [], queryParameters)
    await this.insertOrUpdate(data.items)

    return data.items as TenDlcPhoneNumber[]
  }

  public findNumbersByCampaignId(campaignId: string): TenDlcPhoneNumber[] {
    return this.query().where('campaignId', campaignId).all()
  }
}
